var React = require('react');

function Mg (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#ff3319","d":"M213.3 0H640v240H213.3z","key":0}),React.createElement("path",{"fill":"#00cc28","d":"M213.3 240H640v240H213.3z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 0h213.3v480H0z","key":2})]));
}

Mg.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Mg;

Mg.default = Mg;
